module.exports = __webpack_public_path__ + "img/error.f4526906.jpg";